import React, { FC, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { RouteComponentProps, useParams } from "react-router";
import useFlash from "go-alert/AlertMessage";
import handleError from "go-app/services/errors";
import { useBrowserTabTitle } from "go-core/components/BrowserTab/useBrowserTabTitle";
import { LoadingContainer } from "go-core/components/Loading";
import { NEW_WAY_TO_ENCODING_FILTER_SIGN } from "go-list/core/components/Filter/services";
import { CustomFieldTemplateApi } from "go-segment/services/types";
import { StockAdjustmentApi } from "../../../../../../../../../../services/Api/Organization/types";
import { api } from "../../../../../../../../../../services/Api/api";
import StockAdjustmentPreview from "../../components/StockAdjustmentPreview/StockAdjustmentPreview";

interface MatchParams {
	stockAdjustmentId: string;
}

const OrganizationStockAdjustmentsPreviewPage: FC<RouteComponentProps> = (props) => {
	const [stockAdjustment, setStockAdjustment] = useState<StockAdjustmentApi | undefined>(undefined);
	const [customFieldsConfig, setCustomFieldsConfig] = useState<CustomFieldTemplateApi[] | undefined>(undefined);
	const { addFlash } = useFlash();
	const { stockAdjustmentId } = useParams<MatchParams>();
	const { handleChangeTabTitle } = useBrowserTabTitle();
	const { t } = useTranslation();

	useEffect(() => {
		onFetchStockAdjustment();
	}, []);

	const onFetchStockAdjustment = async () => {
		try {
			const params = { include: "all" };
			const customFieldsParams = {
				f: btoa(`${NEW_WAY_TO_ENCODING_FILTER_SIGN}resource_type|e=STOCK_ADJUSTMENT`),
			};

			const requests: [Promise<StockAdjustmentApi>, Promise<CustomFieldTemplateApi[]>] = [
				api.organization().getStockAdjustment(Number(stockAdjustmentId), params),
				api.organization().getCustomFields(customFieldsParams),
			];
			const [newStockAdjustment, newCustomFieldsConfig] = await Promise.all(requests);
			handleChangeTabTitle(
				`${newStockAdjustment.document_number} | ${t("modules.stock_adjustment.header.title")}`
			);
			setStockAdjustment(newStockAdjustment);
			setCustomFieldsConfig(newCustomFieldsConfig);
		} catch (err) {
			handleError.alert(err, addFlash);
		}
	};

	if (!stockAdjustment) return <LoadingContainer />;

	return (
		<StockAdjustmentPreview
			stockAdjustment={stockAdjustment}
			path={props.match.path}
			onSuccessAction={setStockAdjustment}
			fetchStockAdjustment={onFetchStockAdjustment}
			customFieldsConfig={customFieldsConfig}
		/>
	);
};

export default OrganizationStockAdjustmentsPreviewPage;
